var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import FunctionalButton from "./FunctionalButton";
import CrossIcon from "./icons/CrossIcon";
import TextField, { ETextFieldType } from "./TextField";
import useAuth from "../contexts/useAuth";
import { EPlayerRole } from "cresus-common";
function MediaSettings(props) {
    var _a, _b;
    const { role } = useAuth();
    const refVideo = useRef(null);
    const videoStreamRef = useRef(null);
    const [microphones, setMicrophones] = useState([]);
    const [videos, setVideos] = useState([]);
    const refInput = useRef();
    const refCamera = useRef();
    // Helper to safely get the label for the UI, even if the parent passes an ID
    const selectedMicLabel = ((_a = microphones.find((m) => m.deviceId === props.selectedMicrophone ||
        m.label === props.selectedMicrophone)) === null || _a === void 0 ? void 0 : _a.label) || props.selectedMicrophone;
    const selectedCamLabel = ((_b = videos.find((v) => v.deviceId === props.selectedCamera || v.label === props.selectedCamera)) === null || _b === void 0 ? void 0 : _b.label) || props.selectedCamera;
    function stopVideoPreview() {
        if (videoStreamRef.current) {
            videoStreamRef.current.getTracks().forEach((track) => track.stop());
            videoStreamRef.current = null;
        }
    }
    // function clickClose() {
    //   if (props.onClickClose) props.onClickClose();
    // }
    function clickClose() {
        stopVideoPreview();
        if (props.onClickClose)
            props.onClickClose();
    }
    // function clickValidate() {
    //   if (props.onClickValidate) {
    //     const micro = refInput.current ?? props.selectedMicrophone; // ref are not populated by the Dropdown component if not clicked
    //     const cam = refCamera.current ?? props.selectedCamera;
    //     props.onClickValidate(micro, cam);
    //   }
    // }
    function clickValidate() {
        var _a, _b, _c, _d;
        if (props.onClickValidate) {
            const microLabel = (_a = refInput.current) !== null && _a !== void 0 ? _a : selectedMicLabel;
            const camLabel = (_b = refCamera.current) !== null && _b !== void 0 ? _b : selectedCamLabel;
            // Translate the label back to the exact deviceId to send to the parent
            const microId = ((_c = microphones.find((m) => m.label === microLabel)) === null || _c === void 0 ? void 0 : _c.deviceId) || microLabel;
            const camId = ((_d = videos.find((v) => v.label === camLabel)) === null || _d === void 0 ? void 0 : _d.deviceId) || camLabel;
            stopVideoPreview();
            props.onClickValidate(microId, camId);
        }
    }
    function getMicrophonesLabel() {
        return microphones.map((el) => {
            if (!el.label)
                return "Default Microphone";
            return el.label;
        });
    }
    // function getVideosLabel() {
    //   return videos.map((el) => {
    //     return el.label;
    //   });
    // }
    function getVideosLabel() {
        return videos.map((el) => el.label || "Default Camera");
    }
    // async function updateVideo(name?: string) {
    //   if (navigator.mediaDevices.getUserMedia) {
    //     let videoDevices = await navigator.mediaDevices.enumerateDevices();
    //     videoDevices = videoDevices.filter((el) => el.kind === "videoinput");
    //     let foundCamera: MediaDeviceInfo = videoDevices[0];
    //     if (name) foundCamera = videoDevices.filter((el) => el.label === name)[0];
    //     navigator.mediaDevices
    //       .getUserMedia({ video: { deviceId: { exact: foundCamera.deviceId } } })
    //       .then(function (stream) {
    //         if (refVideo.current) refVideo.current.srcObject = stream;
    //         // Catch to handle the case where the video is not playing (local when not running webaudio server)
    //         refVideo.current
    //           ?.play()
    //           .catch((error) => console.error("Cannot play video", error));
    //       })
    //       .catch(function (error) {
    //         console.error("Cannot getUserMedia", error);
    //       });
    //   }
    // }
    function updateVideo(identifier) {
        return __awaiter(this, void 0, void 0, function* () {
            if (navigator.mediaDevices.getUserMedia) {
                stopVideoPreview(); // Stop the previous preview before starting a new one
                let videoDevices = yield navigator.mediaDevices.enumerateDevices();
                videoDevices = videoDevices.filter((el) => el.kind === "videoinput");
                let foundCamera = videoDevices[0];
                if (identifier) {
                    // Find by ID or Label
                    foundCamera =
                        videoDevices.find((el) => el.label === identifier || el.deviceId === identifier) || videoDevices[0];
                }
                if (!foundCamera)
                    return;
                navigator.mediaDevices
                    .getUserMedia({ video: { deviceId: { ideal: foundCamera.deviceId } } }) // FIX: Use 'ideal' to prevent crashes
                    .then(function (stream) {
                    var _a;
                    videoStreamRef.current = stream;
                    if (refVideo.current)
                        refVideo.current.srcObject = stream;
                    (_a = refVideo.current) === null || _a === void 0 ? void 0 : _a.play().catch((error) => console.error("Cannot play video", error));
                })
                    .catch(function (error) {
                    console.error("Cannot getUserMedia", error);
                });
            }
        });
    }
    // useEffect(() => {
    //   updateVideo(props.selectedCamera);
    //   navigator.mediaDevices
    //     .enumerateDevices()
    //     .then(function (devices) {
    //       const devicesMic = devices.filter((el) => el.kind === "audioinput");
    //       setMicrophones(devicesMic);
    //       const devicedVideos = devices.filter((el) => el.kind === "videoinput");
    //       setVideos(devicedVideos);
    //       // const devicesSpeakers = devices.filter(el => el.kind === "audiooutput");
    //       // setSpeakers(devicesSpeakers);
    //     })
    //     .catch(function (error) {
    //       console.log("Something went wrong!");
    //     });
    // }, []);
    useEffect(() => {
        updateVideo(props.selectedCamera);
        navigator.mediaDevices
            .enumerateDevices()
            .then(function (devices) {
            setMicrophones(devices.filter((el) => el.kind === "audioinput"));
            setVideos(devices.filter((el) => el.kind === "videoinput"));
        })
            .catch(function (error) {
            console.log("Something went wrong loading devices!", error);
        });
        // FIX: Cleanup function so the webcam light turns off if they click away
        return () => {
            stopVideoPreview();
        };
    }, []);
    // function onVideoChange(video: string) {
    //   updateVideo(video);
    // }
    function onVideoChange(videoLabel) {
        var _a;
        // Translate the label selected in the dropdown to an ID for the preview update
        const camId = ((_a = videos.find((v) => v.label === videoLabel)) === null || _a === void 0 ? void 0 : _a.deviceId) || videoLabel;
        updateVideo(camId);
    }
    return (_jsxs("div", Object.assign({ className: "flex justify-center fixed w-full h-full", style: { zIndex: 100 } }, { children: [_jsx("div", Object.assign({ className: "fixed h-full flex items-center justify-center", style: {
                    zIndex: 1,
                    padding: "12px 0px",
                    width: "500px",
                } }, { children: _jsxs("div", Object.assign({ className: "flex flex-col", style: {
                        background: "white",
                        borderColor: "black",
                        borderWidth: "2px",
                        padding: "21px",
                        gap: "16px",
                    } }, { children: [_jsxs("div", Object.assign({ className: "flex flex-row justify-between" }, { children: [_jsx("div", Object.assign({ className: "font-roboto uppercase", style: { fontSize: "18px", color: "#54659F", fontWeight: "700" } }, { children: "Gestion des P\u00E9riph\u00E9riques" })), _jsx("button", Object.assign({ style: { width: "24px", height: "24px" }, onClick: clickClose }, { children: _jsx(CrossIcon, { color: "black" }) }))] })), _jsx(TextField, { value: props.selectedMicrophone, dropdownOptions: getMicrophonesLabel(), parentRef: refInput, label: "Micro", type: ETextFieldType.DROPDOWN }), role === EPlayerRole.ANIMATOR && (_jsxs(_Fragment, { children: [_jsx(TextField, { onChange: onVideoChange, value: props.selectedCamera, dropdownOptions: getVideosLabel(), parentRef: refCamera, label: "Camera", type: ETextFieldType.DROPDOWN }), _jsx("video", { autoPlay: true, ref: refVideo, muted: true })] })), _jsxs("div", Object.assign({ className: "flex flex-row justify-end", style: { gap: "16px", height: "50px" } }, { children: [_jsx(FunctionalButton, { colorMode: 1, isRound: false, text: "Annuler", onClick: clickClose }), _jsx(FunctionalButton, { colorMode: 0, isRound: false, text: "Valider les modifications", onClick: clickValidate })] }))] })) })), _jsx("div", { className: "fixed right-0 w-full h-full", style: {
                    opacity: 0.8,
                    background: "#54659F",
                } })] })));
}
export { MediaSettings };
